import { AGENTCONNECT_FEISHU_APP_TEMPLATE, buildFeishuAuthorizationUrl } from './feishu-app-template.js';
export const FEISHU_REGISTRATION_DOMAIN = 'accounts.feishu.cn';
export const LARK_REGISTRATION_DOMAIN = 'accounts.larksuite.com';
export const LARK_LAUNCHER_DOMAIN = 'open.larksuite.com';
const REGISTRATION_PATH = '/oauth/v1/app/registration';
export class OfficialFeishuRegistrationProvider {
    fetcher;
    constructor(fetcher = fetch) {
        this.fetcher = fetcher;
    }
    async begin(appName, region, preset) {
        const response = await this.request(FEISHU_REGISTRATION_DOMAIN, {
            action: 'begin',
            archetype: AGENTCONNECT_FEISHU_APP_TEMPLATE.archetype,
            auth_method: 'client_secret',
            request_user_info: 'open_id'
        });
        if (!response.verification_uri_complete || !response.device_code) {
            throw new Error('Feishu app registration did not return a device session');
        }
        const verificationUri = new URL(response.verification_uri_complete);
        if (region === 'lark')
            verificationUri.hostname = LARK_LAUNCHER_DOMAIN;
        return {
            authorizationUrl: buildFeishuAuthorizationUrl(verificationUri.toString(), appName, preset),
            deviceCode: response.device_code,
            providerDomain: FEISHU_REGISTRATION_DOMAIN,
            intervalMs: Math.max(1, response.interval ?? 5) * 1000,
            expiresInMs: Math.max(1, response.expires_in ?? 600) * 1000
        };
    }
    async poll(providerDomain, deviceCode) {
        const response = await this.request(providerDomain, { action: 'poll', device_code: deviceCode });
        if (response.user_info?.tenant_brand === 'lark' && providerDomain !== LARK_REGISTRATION_DOMAIN) {
            return { outcome: 'switch_domain', providerDomain: LARK_REGISTRATION_DOMAIN };
        }
        if (response.client_id && response.client_secret) {
            return {
                outcome: 'authorized',
                appId: response.client_id,
                appSecret: response.client_secret,
                ...(response.user_info?.tenant_brand ? { region: response.user_info.tenant_brand } : {})
            };
        }
        if (response.client_id || response.client_secret)
            return { outcome: 'failed' };
        switch (response.error) {
            case 'authorization_pending':
                return { outcome: 'pending' };
            case 'slow_down':
                return { outcome: 'slow_down' };
            case 'access_denied':
                return { outcome: 'denied' };
            case 'expired_token':
                return { outcome: 'expired' };
            case undefined:
                return { outcome: 'pending' };
            default:
                return { outcome: 'failed' };
        }
    }
    async request(providerDomain, params) {
        const response = await this.fetcher(`https://${providerDomain}${REGISTRATION_PATH}`, {
            method: 'POST',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams(params).toString(),
            signal: AbortSignal.timeout(15_000)
        });
        const body = await response.json();
        if (typeof body !== 'object' || body === null || Array.isArray(body)) {
            throw new Error('Feishu app registration returned an invalid response');
        }
        if (!response.ok && typeof Reflect.get(body, 'error') !== 'string') {
            throw new Error('Feishu app registration request failed');
        }
        return body;
    }
}
//# sourceMappingURL=feishu-registration-provider.js.map